import type { NavigationGuard } from 'vue-router'

// Admin-only guard: allows access if authenticated and role === 1 (admin).
export const adminGuard: NavigationGuard = async (to) => {
  const { useAuthStore } = await import('@/stores/auth')
  const authStore = useAuthStore()

  if (typeof authStore.ensureReady === 'function') {
    await authStore.ensureReady(3000)
  }

  // Not authenticated → redirect to access-denied
  if (!authStore.isAuthenticated) {
    return { name: 'access-denied', query: { reason: 'unauthenticated', redirect: to.fullPath } }
  }

  // If role known, decide immediately
  if (authStore.userRole !== null) {
    if (authStore.userRole === 1) {
      return true
    }
    // Non-admin → access denied
    return { name: 'access-denied', query: { reason: 'unauthorized', redirect: to.fullPath } }
  }

  // Role not loaded yet → fetch via RPC
  try {
    await authStore.fetchUserRole()
  } catch (e) {
    console.error('adminGuard: fetchUserRole failed', e)
  }

  if (authStore.userRole === 1) {
    return true
  }

  if (authStore.userRole !== null) {
    return { name: 'access-denied', query: { reason: 'unauthorized', redirect: to.fullPath } }
  }

  // Still unknown → treat as error and force re-auth
  return { name: 'access-denied', query: { reason: 'unauthenticated', redirect: to.fullPath } }
}
